import { createContext } from 'react';

export interface ToastItem {
  id: number;
  message: string;
}

export interface ToastContextValue {
  toast: ToastItem | null;
  showToast: (message: string, durationMs?: number) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);
